export const MESSAGE = {
  USERNAME: "Username",
  PASSWORD: "Password",
  LOG_IN: "Log in",
  FORGET_PASSWORD: "Forget password",
  PLEASE_FILL_USERNAME: "Please fill username",
  PLEASE_FILL_PASSWORD: "Please fill password",
  PLEASE_FILL_MANUFACTURER: "Nhập tên nhà sản xuất",
  PLEASE_FILL_ORIGIN: "Nhập tên xuất xứ",
  PLEASE_CONTACT: "Contact if you forget your password",
  OVERVIEW: "Tổng quan",
  WAREHOUSE: "Kho hàng",
  CREATE_MANUFACTURER: "Tạo nhà sản xuất",
  MANUFACTURER_NAME: "Name",
  ORIGIN_NAME: "Origin name",
  ACTION: "Thao tác",
  LOGIN_FAILED: "Đăng nhập không thành công",
};
